export default __webpack_public_path__ + "static/media/mail.7d0d5522.svg";